/**
 * @description: 艺人报备明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="wr-ybm-report">
        <div class="ybm-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-2">
                    <div ref="ybmTime">
                        <input type="text" class="form-control laydate-icon" v-model="ybmStartTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ybmShop" data-placeholder="请选择消费门店"></select>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="ybm_tit_sel">
                        <option value="stage_name">艺名</option>
                        <option value="waist_tag">腰牌号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="ybm_con_val" :placeholder="ybm_con_phd">
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="ybm_group_txt" ref="ybm_group_txt" readonly @click="ybmEnterGroup">
                    <span class="selection-clear">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">报备状态:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ybm_type">
                        <option value=" ">全部</option>
                        <option value="-1">未报备</option>
                        <option value="1">上班</option>
                        <option value="2">例假</option>
                        <option value="3">陪宴</option>
                        <option value="4">私事</option>
                        <option value="5">其他</option>
                    </select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitYbmTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYbmExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ybmList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ybmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ybmExport_allcheck' @click='ybmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybmExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybmExport_checkModel' value="group_name">
                            <label>组别</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybmExport_checkModel' value="stage_name">
                            <label>艺人姓名</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybmExport_checkModel' value="waist_tag">
                            <label>腰牌号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybmExport_checkModel' value="director_name">
                            <label>主管</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybmExport_checkModel' value="created_at">
                            <label>报备时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybmExport_checkModel' value="type_name">
                            <label>报备状态</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='ybmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='ybmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 组别列表 -->
        <div class="ybm-group">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="ybm_group_name">
                <img src="../../../assets/images/group_search.png" @click="getYbmGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='ybm_group_allcheck' @click='groupYbmCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in ybm_group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='ybm_group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="ybmGroupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="ybmGroupSub()">确定</button>
            </div>
        </div>
        <!-- 地图 -->
        <div class="ele-hide" style="width:550px;height:300px;border:#ccc solid 1px;margin: 20px auto 0;" id="ybmMap"></div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                ybmStartTime: "",
                ybm_field: "stage_name",
                ybm_con_phd: "请输入艺名",
                ybm_con_val: "",
                ybm_group_txt: "",
                ybm_group_allcheck: false,
                ybm_c_group_allcheck: false,
                ybm_group_checkboxModel: [],
                c_ybm_group_checkboxModel: [],
                ybm_group_checkboxData: [],
                ybm_group_name: '',
                ybmExport_allcheck: false,
                c_ybmExport_allcheck: false,
                ybmExport_checkModel: [],
                ybmExport_checkData: ['shop_name', 'group_name', 'stage_name', 'waist_tag', 'director_name', 'created_at', 'type_name'],
                ybmExport_type: 1,
            }
        },
        watch: {
            ybm_group_checkboxModel: {
                handler: function(val, oldVal) {
                    if(this.ybm_group_checkboxModel.length >= this.ybm_group_checkboxData.length) {
                        this.ybm_group_allcheck = true;
                        this.ybm_c_group_allcheck = true;
                    } else {
                        this.ybm_group_allcheck = false;
                        this.ybm_c_group_allcheck = false;
                    }
                },
                deep: true
            },
            ybmExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.ybmExport_checkModel.length >= this.ybmExport_checkData.length) {
                        this.ybmExport_allcheck = true;
                        this.c_ybmExport_allcheck = true;
                    } else {
                        this.ybmExport_allcheck = false;
                        this.c_ybmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.ybmStartTime = moment().format('YYYY-MM-DD');
            _this.innitDate(); // 日期
            // 下拉选项
            $(_this.$refs.ybm_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.ybm_field = $(this).val();
                _this.ybm_con_val = '';
                if(_this.ybm_field == 'stage_name') {
                    _this.ybm_con_phd = '请输入艺名';
                } else if(_this.ybm_field == 'waist_tag') {
                    _this.ybm_con_phd = '请输入腰牌号';
                }
            });
            // 报备状态
            $(_this.$refs.ybm_type).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            });
            _this.shopDatas = [];
            _this.innitInput();  // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ybmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD');
                        }else {
                            this.ybmStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ybmTime).daterangepicker({
                    singleDatePicker: true,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                }, function(start, end, label) {
                    _this.ybmStartTime = start.format('YYYY-MM-DD');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.ybmShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.ybm_group_checkboxModel = [];
                                _this.ybm_group_txt = '';
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            $(_this.$refs.ybmShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.innitYbmTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            // 进入选择组别
            ybmEnterGroup: function() {
                this.c_ybm_group_checkboxModel = this.ybm_group_checkboxModel;
                this.ybm_group_checkboxModel = [];
                this.getYbmGroupData();
                this.ybm_group_checkboxModel = this.c_ybm_group_checkboxModel;
                $('.ybm-list').hide();
                $('.ybm-group').show();
            },
            // 获取组别列表
            getYbmGroupData: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.ybmShop).val(),
                            "key_word": 'personnel',
                            "group_name": _this.ybm_group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.ybm_group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupYbmCheckedAll: function() {
                let _this = this;
                _this.ybm_group_allcheck = _this.ybm_c_group_allcheck;
                if(!_this.ybm_group_allcheck) { // 实现全选
                    _this.ybm_group_checkboxModel = [];
                    _this.ybm_group_checkboxData.forEach(function(item) {
                        _this.ybm_group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.ybm_group_checkboxModel = [];
                }
            },
            // 返回
            ybmGroupBack: function() {
                $('.ybm-group').hide();
                $('.ybm-list').show();
                this.ybm_group_checkboxModel = this.c_ybm_group_checkboxModel;
            },
            ybmGroupSub: function() {
                let _this = this;
                let arr = [];
                _this.ybm_group_checkboxData.forEach(function(item) {
                    _this.ybm_group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.ybm_group_txt = arr.join(',');
                $('.ybm-group').hide();
                $('.ybm-list').show();
            },
            // 表格
            innitYbmTable: function() {
                let _this = this;
                $(_this.$refs.ybmList).bootstrapTable('destroy');
                $(_this.$refs.ybmList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYbmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "10%"
                    }, {
                        field: "group_name",
                        title: "组别",
                        width: "8%"
                    }, {
                        field: "stage_name",
                        title: "艺人姓名",
                        width: "8%"
                    }, {
                        field: "waist_tag",
                        title: "腰牌号",
                        width: "10%"
                    }, {
                        field: "director_name",
                        title: "主管",
                        width: "8%"
                    }, {
                        field: "created_at",
                        title: "报备时间",
                        width: "10%"
                    }, {
                        field: "type_name",
                        title: "报备状态",
                        width: "10%"
                    }, 
                    // {
                    //     field: "address",
                    //     title: "地理位置",
                    //     width: "10%",
                    //     formatter: function(value, row, index) {
                    //         return '<a href="https://api.map.baidu.com/geocoder?address='+ value +'&amp;output=html" target="_blank" class="text-blue">查看地图</a>'
                    //     }
                    // }
                ],
                });
            },
            // 数据
            getYbmList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let stage_name = "",
                    waist_tag = "";
                if(_this.ybm_field == 'stage_name') {
                    stage_name = _this.ybm_con_val;
                } else if(_this.ybm_field == 'waist_tag') {
                    waist_tag = _this.ybm_con_val;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "time": _this.ybmStartTime,
                            "shop_id": $(_this.$refs.ybmShop).val(),
                            "stage_name": stage_name,
                            "waist_tag": waist_tag,
                            "group_id": _this.ybm_group_checkboxModel,
                            "type": $.trim($(_this.$refs.ybm_type).val())
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getPersonnelSignInList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.data.total,
                                rows: data.response.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYbmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/personnelSignInListExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.ybmExport_checkModel = data.response.result.export_fields;
                                _this.ybmExport_type = data.response.result.export_type;
                            } else {
                                _this.ybmExport_checkModel = _this.ybmExport_checkData;
                                _this.ybmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ybmExport_alert)
                }, function() {
                    _this.exportYbmList();
                });
            },
            // 导出字段全选
            ybmExportCheckedAll: function() {
                let _this = this;
                _this.ybmExport_allcheck = _this.c_ybmExport_allcheck;
                if(!_this.ybmExport_allcheck) { // 实现全选
                    _this.ybmExport_checkModel = [];
                    _this.ybmExport_checkData.forEach(function(item) {
                        _this.ybmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.ybmExport_checkModel = [];
                }
            },
            // 导出
            exportYbmList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.ybmExport_checkModel);
                let stage_name = "",
                    waist_tag = "";
                if(_this.ybm_field == 'stage_name') {
                    stage_name = _this.ybm_con_val;
                } else if(_this.ybm_field == 'waist_tag') {
                    waist_tag = _this.ybm_con_val;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/personnelSignInListExport?" +
                    "time=" + _this.ybmStartTime +
                    "&shop_id=" + $(_this.$refs.ybmShop).val() +
                    "&stage_name=" + stage_name +
                    "&waist_tag=" + waist_tag +
                    "&group_id=" + _this.ybm_group_checkboxModel +
                    "&type=" + $.trim($(_this.$refs.ybm_type).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.ybmExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    /* 组别 */
    .ybm-group {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
</style>